module.exports = __webpack_public_path__ + "static/downpaymentAssistanceBg-old-35b1835d4bb7c5ecb9d918a7dbbb7f3d.jpg";